import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { FEATURE_TOGGLE_ANALYTICS, FEATURE_TOGGLE_CASH_FLOW } from "../../../config";

const SwitchView = (props) => {
  const { customersView, setCustomersView, classifierCompanySelected } = props;

  const changeView = (typeView) => {
    setCustomersView(typeView);
    localStorage.setItem("customerViewType", typeView);
  };

  return (
    <div
      style={{
        flex: "0 0 auto",
        display: "flex",
        width: "100%"
      }}
    >
      <div
        style={{
          width: "85%"
        }}
      ></div>
      <div
        style={{
          justifyContent: "flex-end",
          marginRight: "15px",
          display: "flex",
          marginBottom: "-50px",
          marginTop: "20px"
        }}
      >
        <div
          className={customersView === "calendar" ? "iconTypeGrid gs-documents-view-list left active" : "iconTypeGrid gs-documents-view-list left"}
          onClick={() => {
            changeView("calendar");
            if (window.aptrinsic) {
              window.aptrinsic("track", "digital-box:DEADLINES-CALENDARVIEW");
            }
          }}
        >
          <FontAwesomeIcon
            icon={["far", "calendar-alt"]}
            style={{
              fontSize: 16
            }}
          />
        </div>
        {FEATURE_TOGGLE_ANALYTICS === "true" && classifierCompanySelected !== "PERSON" && (
          <div
            className={customersView === "graph" ? "iconTypeGrid gs-documents-view-th center active" : "iconTypeGrid gs-documents-view-th center"}
            onClick={() => {
              changeView("graph");
              if (window.aptrinsic) {
                window.aptrinsic("track", "digital-box:DEADLINES-GRAPHVIEW");
              }
            }}
          >
            <FontAwesomeIcon
              icon={["far", "chart-bar"]}
              style={{
                fontSize: 16,
                marginRight: "8px"
              }}
            />
          </div>
        )}

        {FEATURE_TOGGLE_ANALYTICS === "true" && FEATURE_TOGGLE_CASH_FLOW === "true" && classifierCompanySelected !== "PERSON" && (
          /* myType !== "STUDIO" && */ <div
            className={customersView === "cashFlow" ? "iconTypeGrid gs-documents-view-th center active" : "iconTypeGrid gs-documents-view-th center"}
            onClick={() => {
              changeView("cashFlow");
              if (window.aptrinsic) {
                window.aptrinsic("track", "digital-box:DEADLINES-CASHFLOW");
              }
            }}
          >
            <FontAwesomeIcon
              icon={["far", "chart-line"]}
              style={{
                fontSize: 16,
                marginRight: "8px"
              }}
            />
          </div>
        )}
        <div
          className={customersView === "list" ? "iconTypeGrid gs-documents-view-th right active" : "iconTypeGrid gs-documents-view-th right"}
          onClick={() => changeView("list")}
        >
          <FontAwesomeIcon
            icon={["far", "list"]}
            style={{
              fontSize: 16,
              marginRight: "8px"
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default SwitchView;
